import { NgTemplateOutlet } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import confetti from 'canvas-confetti';

export interface CongratsDialogData {
  title: string;
  body: string;
  hasAdvocacyPoints: boolean;
  dataAnalytics?: string[];
  tierName?: string;
  points?: string;
  badgePath?: string;
  urlLink?: string;
  urlLinkLabel?: string;
}

@Component({
  selector: 'app-congrats-dialog',
  templateUrl: './congrats-dialog.component.html',
  styleUrls: ['./congrats-dialog.component.scss'],
  imports: [NgTemplateOutlet, MatDialogModule, MatTooltipModule, MatIconModule],
})
export class CongratsDialogComponent implements OnInit {
  readonly dialogRef = inject<MatDialogRef<any>>(MatDialogRef);
  data = inject<CongratsDialogData>(MAT_DIALOG_DATA);
  private router = inject(Router);

  @ViewChild('dialogContent') dialogContent: ElementRef;

  /**
   * String identifiers for analytics services to track this tile, joined with hyphen in HTML
   */
  dataAnalytics: string[];
  dataAnalyticsCopy: string;
  dataAnalyticsClose: string;
  dataAnalyticsOpenInNew: string;

  ngOnInit(): void {
    const svgPath = `
            M57.2758 91.2997H43.9263C38.4934 91.2997 33.2831 93.412 29.4415 97.1719C25.5998 100.932 23.4417 106.031 23.4417 111.349C23.4417 116.666 25.5998 121.765 29.4415 125.525C33.2831 129.285 38.4934 131.397 43.9263 131.397H57.2758C62.7087 131.397 67.9191 129.285 71.7607 125.525C75.6023 121.765 77.7605 116.666 77.7605 111.349C77.7605 106.031 75.6023 100.932 71.7607 97.1719C67.9191 93.412 62.7087 91.2997 57.2758 91.2997Z
            M55.9764 39.481H22.0236C16.1826 39.481 10.5808 41.7557 6.45056 45.8048C2.32034 49.854 0 55.3458 0 61.0721C0 66.7984 2.32034 72.2902 6.45056 76.3393C10.5808 80.3884 16.1826 82.6632 22.0236 82.6632H55.9764C58.8686 82.6632 61.7324 82.1047 64.4045 81.0197C67.0765 79.9346 69.5044 78.3442 71.5494 76.3393C73.5945 74.3344 75.2168 71.9542 76.3236 69.3346C77.4304 66.7151 78 63.9075 78 61.0721C78 58.2367 77.4304 55.4291 76.3236 52.8095C75.2168 50.19 73.5945 47.8098 71.5494 45.8048C69.5044 43.7999 67.0765 42.2095 64.4045 41.1245C61.7324 40.0394 58.8686 39.481 55.9764 39.481Z
            M46.8835 15.4222C46.8835 6.90477 53.7883 0 62.3058 0C70.8232 0 77.728 6.90477 77.728 15.4222C77.728 23.9397 70.8232 30.8445 62.3058 30.8445C53.7883 30.8445 46.8835 23.9397 46.8835 15.4222Z`;

    const genesysLogo = confetti.shapeFromPath({ path: svgPath });

    confetti({
      particleCount: 300,
      spread: 500,
      scalar: 3,
      ticks: 300,
      gravity: 0.5,
      zIndex: 999999,
      shapes: [genesysLogo],
      colors: [
        '#18CAA8', // $patina-500
        '#B1CADA', // $arctic-500
        '#F7AD00', // $amber-500
        '#2243A2', // $azure-500
        '#FF451A', // $orange-500
      ],
    });
  }

  /**
   * Return boolean if url is an external url vs internal route
   */
  get isExternalUrl(): boolean {
    const url = this.data.urlLink || '';
    return url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//');
  }

  /**
   * Handle link navigation
   * @param event - handle click event
   * @returns
   */
  handleLinkClick(event: Event): void {
    event.preventDefault();
    const url = this.data.urlLink;
    if (!url) return;
    // Close the dialog on redirect
    this.dialogRef.close();
    if (this.isExternalUrl) {
      window.open(url, '_blank');
    } else {
      this.router.navigateByUrl(url);
    }
  }
}
